module.exports = __webpack_public_path__ + "static/media/Profile.782adc2b.png";